// extracted by mini-css-extract-plugin
module.exports = {"textField":"ChangePassword_textField__1ToHW","errorText":"ChangePassword_errorText__3_88B"};